<template>
  <transition name="fade">
    <div class="ui-alert" v-show="value" @click.self="handleClose">
      <transition name="scale">
        <div class="alert-container" v-show="value">
          <div class="ui-alert-msg">
            <h1 class="title">
              {{ title }}
            </h1>
            <p class="content">
              {{ content }}
            </p>
            <div class="btn-wrapper">
              <button class="btn btn-cancel" v-show="showCancel" @click="handleCancel">{{ cancelTxt }}</button>
              <i class="bar" v-show="showCancel"></i>
              <button class="btn btn-sure" @click="handleSure">{{ sureTxt }}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "alertMsg",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: [String, Number],
      default: "取消"
    },
    sureTxt: {
      type: [String, Number],
      default: "确定"
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    canClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit("input", false)
      this.$emit("cancel")
    },
    handleSure() {
      this.$emit("input", false)
      this.$emit("sure")
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-alert-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.3rem 0;
  width: 5.2rem;
  height: auto;
  background: #ffffff;
  .title {
    font-family: PingFangSC-Medium;
    font-size: 0.34rem;
    color: #333333;
    font-weight: bold;
    margin: 0;
    padding: 0;
  }
  .content {
    margin: 0.34rem 0 0.5rem;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #333333;
  }
  .btn-wrapper {
    border-top: 1px solid #eeeeee;
    display: flex;
    height: 1rem;
    width: 100%;
    align-items: center;
    .bar {
      height: 0.36rem;
      border-left: 1px solid #eeeeee;
      flex: none;
    }
    .btn {
      border: none;
      outline: none;
      background: transparent;
      display: block;
      height: 100%;
      flex: 1;
      line-height: 1rem;
      font-family: PingFangSC-Medium;
      font-size: 0.32rem;
      color: #999999;
      font-weight: bold;
      &.btn-sure {
        color: #f64e45;
      }
      &:active {
        background: #f0f0f0;
      }
    }
  }
}
.ui-alert {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.fade-enter,
.fade-leave-to {
  background: rgba(0, 0, 0, 0);
}
.fade-enter-to,
.fade-leave {
  background: rgba(0, 0, 0, 0.5);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.scale-enter {
  opacity: 0;
  transform: scale(1.2);
}
.scale-enter-to {
  opacity: 1;
  transform: scale(1);
}
.scale-leave {
  opacity: 1;
}
.scale-leave-to {
  opacity: 0;
}
.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
